"use strict";
import serviceBase from "./serviceBase";
const usersService = {
  reserveYourStay: (data) =>
    serviceBase.post("/appleIntern/reserveyourstay", data),
};
export default usersService;
